import { render, staticRenderFns } from "./GmailLogo.vue?vue&type=template&id=179e2038&scoped=true&"
import script from "./GmailLogo.vue?vue&type=script&lang=ts&"
export * from "./GmailLogo.vue?vue&type=script&lang=ts&"
import style0 from "./GmailLogo.vue?vue&type=style&index=0&id=179e2038&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179e2038",
  null
  
)

export default component.exports